/**
 * Clasificación estándar de NPS, la misma que usa el backend y la que usaba el
 * dashboard de Retool: 0-6 detractor, 7-8 pasivo, 9-10 promotor.
 * El 0 es un puntaje VÁLIDO (el detractor más extremo), no un vacío.
 */
export type NpsClassification = 'detractor' | 'passive' | 'promoter';

export const classifyNps = (score: number): NpsClassification => {
  if (score <= 6) return 'detractor';
  if (score <= 8) return 'passive';
  return 'promoter';
};

const CLASSIFICATION_COLORS: Record<NpsClassification, string> = {
  detractor: 'red',
  passive: 'amber darken-2',
  promoter: 'green',
};

/** Color de Vuetify para un puntaje 0-10, según su clasificación. */
export const npsScoreColor = (score: number): string => (
  CLASSIFICATION_COLORS[classifyNps(score)]
);

/**
 * El NPS se muestra SIEMPRE con signo: +42 y −12 significan cosas muy distintas
 * y un "42" pelado se lee como un porcentaje.
 */
export const formatNpsScore = (value: number): string => {
  const rounded = Math.round(value || 0);
  return rounded > 0 ? `+${rounded}` : String(rounded);
};

/** Convención de la industria: negativo malo, 0-30 aceptable, >30 bueno. */
export const npsScoreTextClass = (value: number): string => {
  const score = value || 0;
  if (score < 0) return 'red--text';
  if (score < 30) return 'amber--text text--darken-2';
  return 'green--text';
};
